module.exports = __webpack_public_path__ + "static/media/question-icon.96fe004f.svg";